<ion-modal
  data-testid="auth-modal"
  [isOpen]="isOpen"
  [attr.aria-label]="title"
  [backdropDismiss]="true"
  [keyboardClose]="true"
  (didDismiss)="handleDidDismiss()"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
          <app-loading-button size="small" fill="clear" (clicked)="close()">
            <ion-icon slot="start" name="close-outline" aria-hidden="true"></ion-icon>
            {{ closeLabel }}
          </app-loading-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="login-modal">
      <div class="login-modal__body">
        <ion-text color="medium">
          <p>{{ message }}</p>
        </ion-text>
        <ion-list class="login-modal__form" *ngIf="showPasswordForm">
          <ion-item lines="full">
            <ion-label position="stacked">Email</ion-label>
            <ion-input
              type="email"
              [placeholder]="emailPlaceholder"
              [(ngModel)]="email"
              [disabled]="loading"
              data-testid="auth-email"
            ></ion-input>
          </ion-item>
          <ion-item lines="full">
            <ion-label position="stacked">Password</ion-label>
            <ion-input
              type="password"
              [(ngModel)]="password"
              [disabled]="loading"
              data-testid="auth-password"
            ></ion-input>
          </ion-item>
        </ion-list>
        <div class="login-modal__actions">
          <app-loading-button
            *ngIf="showPasswordForm"
            expand="block"
            size="small"
            fill="outline"
            [loading]="loading && loadingAction === 'signin'"
            [disabled]="loading"
            data-testid="auth-signin"
            loadingAriaLabel="Signing in"
            (clicked)="submitSignIn()"
          >
            <ion-icon slot="start" name="mail-outline" aria-hidden="true"></ion-icon>
            {{ signInLabel }}
          </app-loading-button>
          <app-loading-button
            *ngIf="showGoogleButton"
            expand="block"
            size="small"
            fill="outline"
            color="danger"
            [loading]="loading && loadingAction === 'google'"
            [disabled]="loading"
            data-testid="auth-signin-google"
            loadingAriaLabel="Signing in with Google"
            (clicked)="requestGoogleSignIn()"
          >
            <ion-icon slot="start" name="logo-google" aria-hidden="true"></ion-icon>
            {{ googleButtonLabel }}
          </app-loading-button>
        </div>
        <ion-text color="danger" *ngIf="error" role="alert" class="login-modal__error">
          <p>{{ error }}</p>
        </ion-text>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
